<div class="widget">
    <h4>Sponsored</h4>
    <ul>
        <li *ngFor="let post of sponsoredPosts">
            <strong>{{ post.PostTitle }}</strong>
            <p>{{ post.PostContent }}</p>
        </li>
    </ul>
</div>
